import React from 'react'

import { GameWithUserInformation } from 'containers/GamesBlock/types'

import { GamePlayLinks } from '../../GamePlayLinks'
import { LinksBox } from './styles'

interface Props {
  game: GameWithUserInformation
}

export function DesktopLinks({ game }: Props) {
  return (
    <LinksBox>
      <GamePlayLinks game={game} />
    </LinksBox>
  )
}
